export const roles = {
  title: 'Roles',
  deleteRole: 'Delete role',
  deletedQuestion: 'Are you sure you want to delete the role: {roleName}?',
  editRole: 'Edit role',
  addRole: 'Create role',
  name: 'Name',
  deleteSuccess: 'Role deleted',
  add: 'Create new role',
  titles: {
    flowEngine: 'Flow permissions',
    users: 'Client permissions',
    roles: 'Administrator permissions',
  },

  createdRole: 'Role created',
  savedChanges: 'Changes saved',
  tooltips: {
    edit: 'Edit role',
    delete: 'Delete role',
  },
}
